import api from './api';

const cardRatesService = {
  getAllRates: async () => {
    try {
      const response = await api.get('/card-rates');
      return response.data.data || [];
    } catch (error) {
      console.warn('Taxas de cartão descontinuadas/não configuradas:', error.message);
      return [];
    }
  },

  getRates: async () => {
    try {
      const response = await api.get('/card-rates');
      return response.data || { data: [] };
    } catch (error) {
      return { data: [] };
    }
  },

  saveRates: async (rates) => {
    try {
      const response = await api.post('/card-rates/bulk', { rates });
      return response.data;
    } catch (error) {
      console.error('Erro ao salvar taxas de cartão:', error);
      throw error;
    }
  },
};

export default cardRatesService;